<template>
  <el-select
    v-loading="loading"
    v-model="EmployeeSelected"
    @change="hanldeSelection()"
    :placeholder="placeholder"
    :size="size"
    clearable
    filterable
    v-bind="$attrs"
    :disabled="disabled"
  >
    <el-option
      v-for="item in employeList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "EmployeeSelector",
  props: {
    placeholder: {
      required: false,
      type: String
    },
    all: {
      type: Boolean,
      required: false
    },

    DireccionParams: {
      type: Number,
      required: false
    },

    DeparmentParams: {
      type: Number,
      required: false
    },

    CurrentEmployee: {
      type: Number,
      required: false
    },

    disabled: {
      type: Boolean,
      required: false
    },
    onlySupervisor: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      default: "mini"
    }
  },

  created() {
    this.loading = true;
    // const company = this.currentCompany;
    const isValid = this.IsInRoles([this.roles.CEO, this.roles.SuperUsuario]);
    //const employeeId = this.currentUser.EmployeeId;
    const directionId = isValid
      ? this.directionId > 0
      : this.currentUser.DireccionID;

    const _params = {
      DireccionId:
        this.DireccionParams !== 0 ? this.DireccionParams : this.directionId,
      Employeeid: this.currentUser.EmployeeId,
      DepartmentID: this.DeparmentParams,
      onlySupervisor: this.onlySupervisor
      // CompanySelected: this.currentCompany
    };

    let uri = "";
    let self = this;
    if (directionId > 0) {
      uri = `/api/Employees/getEmployeeByhierarchy`;
    } else {
      uri = "/api/CMI/Objetives/GetUsersObjetivos";
    }
    if (this.all) {
      uri =
        "/api/Employees/EmployeesByCompany?companyID=" + this.currentCompany;
      this.$http
        .get(uri, {})
        .then(({ data }) => {
          const a = formatArrayToElSelect(data, {
            value: "EmployeeID"
          });
          this.employeList = a;
          self.$emit("list-employee", a);
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        })
        .finally(() => (this.loading = false));
    } else {
      this.getEmployeeByParams(uri, _params, self);
    }
    this.EmployeeSelected =
      this.CurrentEmployee == 0 ? "" : this.CurrentEmployee;
  },
  data() {
    return {
      EmployeeSelected: "",
      employeList: [],
      loading: true
    };
  },
  beforeCreated() {
    this.EmployeeSelected =
      this.CurrentEmployee == 0 ? "" : this.CurrentEmployee;
  },
  methods: {
    getEmployeeByParams(uri, _params, self) {
      this.$http
        .get(uri, { params: { ..._params } })
        .then(({ data }) => {
          const a = formatArrayToElSelect(data, {
            value: "EmployeeID"
          });
          this.employeList = a;
          self.$emit("list-employee", a);
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    hanldeSelection() {
      if (this.EmployeeSelected) {
        this.$emit("selection-change", this.EmployeeSelected);
      } else {
        this.$emit("selection-change", 0);
      }
    }
  },

  watch: {
    DireccionParams(/*p*/) {
      const _params = {
        DirectionID: this.DireccionParams,
        Employeeid: this.currentUser.EmployeeId,
        DepartmentID: this.DeparmentParams,
        CompanySelected: this.currentCompany
      };

      this.getEmployeeByParams(
        `/api/Employees/getEmployeeByhierarchy`,
        _params,
        this
      );
    },
    DeparmentParams(/*p*/) {
      const _params = {
        DirectionID: this.DireccionParams,
        Employeeid: this.currentUser.EmployeeId,
        DepartmentID: this.DeparmentParams,
        CompanySelected: this.currentCompany
      };

      this.getEmployeeByParams(
        `/api/Employees/getEmployeeByhierarchy`,
        _params,
        this
      );
    },
    CurrentEmployee(value) {
      if (value === 0) {
        this.EmployeeSelected = "";
      } else {
        this.EmployeeSelected = value;
      }
    }
  }
};
</script>

<style></style>
